
<script>
import simplebar from "simplebar-vue";

/**
 * Nav-bar Component
 */
export default {
  components: { simplebar },
  computed: {
    puedeVerProyeccion() {
      const permission = document.querySelector('meta[name="enrollment-projection-preview"]');
      return !!permission && permission.content === '1';
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    }
  }
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box d-flex align-items-center justify-content-center">
          <a href="/" class="logo logo-dark text-center">
            <span class="logo-sm">
              <img src="/images/Logo Corporativo blanco completo (Sin slogan).png" alt="UGM" style="max-width:120px; width:100%; height:auto;" />
            </span>
            <span class="logo-lg">
              <img src="/images/Logo Corporativo blanco completo (Sin slogan).png" alt="UGM" style="max-width:180px; width:100%; height:auto;" />
            </span>
          </a>

          <a href="/" class="logo logo-light text-center">
            <span class="logo-sm">
              <img src="/images/Logo Corporativo blanco completo (Sin slogan).png" alt="UGM" style="max-width:120px; width:100%; height:auto;" />
            </span>
            <span class="logo-lg">
              <img src="/images/Logo Corporativo blanco completo (Sin slogan).png" alt="UGM" style="max-width:180px; width:100%; height:auto;" />
            </span>
          </a>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <a
          v-if="puedeVerProyeccion"
          href="/web/dashboard/proyeccion"
          class="header-item d-flex align-items-center px-2"
          title="Proyección de matrículas"
          aria-label="Abrir proyección de matrículas"
        >
          <i class="mdi mdi-chart-timeline-variant font-size-20 mr-1" aria-hidden="true"></i>
          <span class="d-none d-sm-inline">Proyección</span>
        </a>

        <!-- App Search-->
        
      </div>

      <div class="d-flex">
        

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <i class="mdi mdi-account-circle font-size-22 align-middle mr-1"></i>
            <span class="ml-1">{{user.name}}</span>
            <i class="mdi mdi-chevron-down ml-1"></i>
          </template>
          <!-- item-->
          <a class="dropdown-item" href="/web/configuracion/cambiarcontraseña">
            <i class="bx bx-key font-size-16 align-middle mr-1"></i> Cambiar contraseña
          </a>
          <!--<a class="dropdown-item" href="javascript: void(0);">
            <i class="bx bx-wallet font-size-16 align-middle mr-1"></i> My Wallet
          </a>
          <a class="dropdown-item d-block" href="javascript: void(0);">
            <span class="badge badge-success float-right">11</span>
            <i class="bx bx-wrench font-size-16 align-middle mr-1"></i> Settings
          </a>
          <a class="dropdown-item" href="javascript: void(0);">
            <i class="bx bx-lock-open font-size-16 align-middle mr-1"></i> Lock screen
          </a> -->
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="/logout">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Salir
          </a>
        </b-dropdown>

        <!-- <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div> -->
      </div>
    </div>
  </header>
</template>
